module.exports = __webpack_public_path__ + "img/SEJ_Eventos_opciones-21.6968cf50.svg";